<div class="">

    <div class="flex justify-between items-center mb-4">
        <div class="max-w-sm ">
            <div role="tablist" class="tabs border tabs-boxed gap-1">
              @for (i of tabs; track $index) {
                <a role="tab" class="tab capitalize" [ngClass]="{'tab-active': currentTab === i.value}" (click)="currentTab = i.value">{{i.name}}</a>
              }
              </div>
          </div>
          <button class="btn btn-sm flex items-center btn-primary"><i class="ri-chat-new-line font-thin"></i> Create Message</button>
    </div>

    <div class="overflow-x-auto w-full p-5 bg-white rounded-lg border">
        <table class="table table-auto w-full ">
            <!-- head -->
            <thead>
                <tr>
                    @for (i of data.label; track $index) {
                    <th>{{i}}</th>
                    }
                </tr>
            </thead>
            <tbody>
                <!-- row 1 -->
                @for (i of data.data; track $index) {
                <tr>
                    @for (j of i; track $index) {
    
                    <td>{{j}}</td>
                    }
    
                </tr>
                }
            </tbody>
        </table>
    </div>




</div>
